import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  product: {
    id: "x/ZVlU",
    defaultMessage: "Product",
  },
  quantity: {
    id: "nEWp+k",
    defaultMessage: "Quantity",
    description: "quantity of ordered products",
  },
  variantName: {
    id: "OK5+Fh",
    defaultMessage: "Variant",
  },
  price: {
    id: "32dfzI",
    defaultMessage: "Price",
    description: "price or ordered products",
  },
  total: {
    id: "lVwmf5",
    defaultMessage: "Total",
    description: "total price of ordered products",
  },
  isGift: {
    id: "J3W5LI",
    defaultMessage: "Is gift",
    description: "order line is gift",
  },
  status: {
    id: "tzMNF3",
    defaultMessage: "Status",
  },
});

export const messages = defineMessages({
  emptyText: {
    id: "Q1Uzbb",
    defaultMessage: "No products found",
  },
  productDetails: {
    id: "VYK2nN",
    defaultMessage: "Product details",
  },
  deleteOrder: {
    id: "LKD6fB",
    defaultMessage: "Remove product",
  },
  editDiscount: {
    id: "DhFqJF",
    defaultMessage: "Edit discount",
  },
  showMetadata: {
    id: "11ep0q",
    defaultMessage: "Show metadata",
    description: "button",
  },
});
